// extracted by mini-css-extract-plugin
export default {"relationChip":"RelationChipItem_relationChip__9ECgv","relationChipRemove":"RelationChipItem_relationChipRemove__r-hIp"};